// import transformAsset from "./transform-appcreator-assets.js";

const documentation = `# Event Trigger Node

The **Event Trigger Node** listens for specific messages and triggers actions when matching messages are received.

## Parameters

| Name | Description | Required | Example |
|------|--------------|-----------|----------|
| \`topic\` | MQTT topic to subscribe to | * | \`home/livingroom/light\` |
| \`payload\` | Expected message payload to trigger the event | * | \`{"status": "on"}\` |
| \`external_broker_host\` | Host address of an external MQTT broker |  | \`mqtt.example.com\` |
| \`external_broker_port\` | Port of the external MQTT broker |  | \`1883\` |
| \`external_broker_username\` | Username for broker authentication |  | \`user123\` |
| \`external_broker_password\` | Password for broker authentication |  | \`secretpass\` |

## Description

This node triggers an event when a message matching the specified **topic** and **payload** is received from a broker.

If no external broker details are provided, the node will use the **system's default broker**.

## Example

Suppose you want to trigger an event when a light in your living room turns on:

- **Topic:** \`home/livingroom/light\`  
- **Payload:** \`{"status": "on"}\`

When a message with this payload is received on that topic, the event will be triggered automatically.

## Typical Use Case

Example:  
> *If the temperature exceeds 30°C, trigger an event to turn on the air conditioner.*

You could configure a preceding node to publish this condition to a specific topic, and use the Event Trigger Node to listen for it and react accordingly.
`;

export default documentation;
